import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Contact} from './contact.model';
import {ContactService} from './contact.service';
import {UserService} from '../user/user.service';
import {User} from '../user/user.model';
import {UIRouter} from '@uirouter/angular';
import {CombiFormComponent} from '../shared/combi-form.component';
import {EnumerationInterface} from '../enumeration/enumeration.interface';
import {EnumerationService} from '../enumeration/enumeration.service';
import {RoutePrefix} from '../shared/route-prefix';
import {RequestParams} from '@ngx-ivengi/crud';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html'
})
export class ContactFormComponent extends CombiFormComponent implements OnInit, OnDestroy {
  public contact: Contact = new Contact();
  public users: User[];
  public contactPermissions: EnumerationInterface;
  public stateIdParam: string = 'contactId';
  public formTitle: string;
  public entityType;
  @Input() public routePrefix: RoutePrefix | RoutePrefix[];
  @Input() public contactFilter: any;

  constructor(
    protected router: UIRouter,
    private enumerationService: EnumerationService,
    private contactService: ContactService,
    private userService: UserService,
    private translate: TranslateService
  ) {
    super(router);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.translate.get('contact.form.add.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });
      } break;

      case this.FormMode.UPDATE: {
        this.translate.get('contact.form.edit.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });

        this.contactService.get(this.router.stateService.params.contactId).subscribe((contact: Contact) => {
          this.contact = contact;
        });
      } break;
    }

    if(this.routePrefix) {
      const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];
      this.entityType = prefixParts[0].entity;

      const prefix  = prefixParts.map((item) => {
        return `${item.entity}/${item.entityId}`;
      });

      this.contactService.setRoutePrefix(prefix.join('/').toLowerCase());
    }

    this.enumerationService.get('contact-permission').subscribe((contactPermissions: EnumerationInterface) => {
      this.contactPermissions = contactPermissions;
    });

    const requestParams = new RequestParams();
    requestParams.pagination.limit = 0;
    requestParams.addFilterParam(this.contactFilter);
    this.userService.getAll(requestParams).subscribe((users: User[]) => {
      this.users = users;
    });
  }

  public ngOnDestroy(): void {
    this.contactService.clearRoutePrefix();
  }

  public save() {
    const redirectState = this.router.stateService.$current.name.split('contact')[0].replace(/(\.)$/, '');

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.contactService.add(this.contact).subscribe((response) => {
          const stateParts = this.router.stateService.$current.name.split('.');
          stateParts.pop();
          this.router.stateService.go(redirectState, this.router.stateService.params, {reload: true});
        });

      } break;

      case this.FormMode.UPDATE: {
        this.contactService.update(this.contact).subscribe((response) => {
          const stateParts = this.router.stateService.$current.name.split('.');
          stateParts.pop();
          this.router.stateService.go(redirectState, this.router.stateService.params, {reload: true});
        });

      } break;
    }

  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/contact/contact-form.component.ts